import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';
import { CONSTANTS } from './app/constants/constants';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { UtilsService } from './app/services/utils.service';

if (environment.production) {
  enableProdMode();
}

if (!UtilsService.isLocalHost()) {
  Sentry.init({
    dsn: CONSTANTS.SENTRY_DSN,
    release: UtilsService.isProd() ? 'prod' : 'dev',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => {
    /* eslint-disable-next-line no-console */
    console.error(err);
  });
